import { HttpParams } from '@angular/common/http';

export class LoadingDropdownSettings {
  private static readonly startItemNumberParam = 'startItemNumber';
  private static readonly chunkSizeParam = 'chunkSize';
  private static readonly searchTermParam = 'searchTerm';
  private static readonly selectedItemIdParam = 'selectedItemId';

  private static readonly defaultStartNumber = 0;
  private static readonly defaultChunkSize = 30;

  public startItemNumber: number;
  public chunkSize: number;
  public searchTerm: string;

  public selectedItemId: string;

  public get isFirstChunkRequested(): boolean {
    return this.startItemNumber === LoadingDropdownSettings.defaultStartNumber;
  }

  constructor() {
    this.setDefaultSettings();
  }

  public getHttpParams(): HttpParams {
    let params = new HttpParams().set(LoadingDropdownSettings.startItemNumberParam, this.startItemNumber.toString());
    params = params.set(LoadingDropdownSettings.chunkSizeParam, this.chunkSize.toString());
    if (this.searchTerm) {
      params = params.set(LoadingDropdownSettings.searchTermParam, this.searchTerm);
    }
    if (this.selectedItemId) {
      params = params.set(LoadingDropdownSettings.selectedItemIdParam, this.selectedItemId);
    }

    return params;
  }

  public reset(): void {
    this.setDefaultSettings();
  }

  private setDefaultSettings(): void {
    this.startItemNumber = LoadingDropdownSettings.defaultStartNumber;
    this.chunkSize = LoadingDropdownSettings.defaultChunkSize;
    this.searchTerm = null;
    this.selectedItemId = null;
  }
}
